import { Inject, Injectable } from '@angular/core';
import { filterFormats, setFormatName, sortFormats } from '@thehubz/client/asset-services';
import { ClientEnvironment, ENVIRONMENT, FormatFileSizePipe } from '@thehubz/client/core';
import { AssetAspectRatio, AssetDetails, AssetFileFormat } from '@thehubz/client/data-access-api';

@Injectable({
  providedIn: 'root',
})
export class TransformObjectService {
  constructor(
    @Inject(ENVIRONMENT) private readonly env: ClientEnvironment,
    private formatFileSize: FormatFileSizePipe,
  ) {}

  /**
   * Transform AssetDetails model to mat-tree child-parent model`
   * @param assetFileFormat
   * @returns
   */
  transformAssetDetails = (assetFileFormat: AssetDetails[]) => {
    let children = {};
    if (assetFileFormat && Array.isArray(assetFileFormat)) {
      children = assetFileFormat.map((asset) => {
        const aspectRatioArr = asset.aspectRatios?.map((aspectRatio: AssetAspectRatio) => {
          const format = aspectRatio.formats
            ?.filter(filterFormats(this.env))
            .sort(sortFormats(this.env))
            .map(setFormatName(this.formatFileSize))
            .map((format: AssetFileFormat) => {
              return Object.assign({}, format, {
                tempName: format.name,
              });
            });

          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { formats, ...newAspectRatio } = aspectRatio;
          return {
            name: aspectRatio.aspectRatioName ? $localize`Aspect ratio: ${aspectRatio.aspectRatioName}` : $localize`Default format`,
            ...newAspectRatio,
            children: format,
          };
        });
        return {
          name: asset.name,
          id: asset.assetId,
          version: asset.version,
          children: aspectRatioArr,
        };
      });
    }
    return children;
  };
}
